import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { StatusCode } from '../_enums/Common';
import { IdServer } from '../_enums/idServer';
import { CommonService } from '../_services/app.common.service';



@Injectable()
export class TokenResolver  {
  constructor(public authService: AuthenticationService, private router: Router, private common: CommonService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    const tokenType = route.data.tokenType;
    return this.authService.GetTokenByType(tokenType).pipe(map(response => {

      if (response) {
        if (IdServer.TokenType.Sso == tokenType || IdServer.TokenType.ATSLogin == tokenType) {
          this.common.SetAccessToken(response.resultData);
          // let url = this.authService.getRedirectUrl();
          // this.router.navigateByUrl(url);
          this.common.RemoveLocalStorage("QuickLinks");

          this.authService.GetOwnSecurityRole(() => {
            let userInfo = this.common.JsonParseData(this.common.GetFromLocalStorage('jt_user_info'));
            if (!this.common.isNullOrWhiteSpace(userInfo)) {
              userInfo.forcePasswordChange = 'No';
              this.common.SetLocalStorage('jt_user_info', JSON.stringify(userInfo));
            }
          });
        }
        if (IdServer.TokenType.SSOLogin == tokenType) {
          location.href = response.resultData;
        }
        return response;
      } else {
        // this.router.navigate(['404']);
        return null;
      }
    }));


  }

}
